<script lang="ts">
  import DownloadReport from "$lib/components/DownloadReport.svelte";

</script>

<DownloadReport />